export interface NavLink {
  label: string;
  href: string;
}

export interface HeroCard {
  tag: string;
  title: string;
  summary: string;
  author: string;
  time: string;
  comments: string;
  image: string;
  imageAlt: string;
}

export interface FeaturedItem {
  badge: string;
  tag: string;
  title: string;
  summary: string;
  author: string;
  time: string;
  comments: string;
  read: string;
  image: string;
  imageAlt: string;
}

export interface FlashItem {
  time: string;
  tag: string;
  text: string;
}

export interface HeadlineItem {
  tag: string;
  title: string;
  summary: string;
  source: string;
  time: string;
  comments: string;
}

export interface RecallItem {
  title: string;
  time: string;
}

export interface RankItem {
  rank: number;
  title: string;
  heat: number;
  trend: "up" | "down" | "same";
  delta: string;
}

export interface RankTab {
  key: string;
  label: string;
  items: RankItem[];
}

export interface ThreadItem {
  avatar: string;
  name: string;
  role: string;
  time: string;
  title: string;
  summary: string;
  tags: string[];
  replies: string;
  likes: string;
}

export interface GalleryItem {
  image: string;
  imageAlt: string;
  title: string;
  tag: string;
}

export interface TrustPoint {
  icon: string;
  title: string;
  desc: string;
}

export interface TrustStat {
  value: string;
  label: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const siteBrand = {
  name: "黑料首页",
  tagline: "头版焦点 · 一屏看清今天谁在顶上",
  today: "2026 年 9 月 12 日 星期六",
  updateTime: "刚刚更新",
};

export const navLinks: NavLink[] = [
  { label: "头版焦点", href: "#focus" },
  { label: "短讯快报", href: "#flash" },
  { label: "今日要闻", href: "#headlines" },
  { label: "热瓜榜", href: "#rank" },
  { label: "讨论区", href: "#discussion" },
  { label: "爆料图鉴", href: "#gallery" },
  { label: "信任与解答", href: "#trust" },
];

export const heroFeatured: FeaturedItem = {
  badge: "置顶爆料",
  tag: "娱乐瓜田",
  title: "某顶流工作室深夜连发三条动态，评论区两小时涌入十万条",
  summary:
    "从行程临时变动到团队换血传闻，线索被网友逐条拼图。三条动态措辞一次比一次谨慎，唯独对核心质疑只字未提，事件仍在发酵。",
  author: "吃瓜小分队",
  time: "32 分钟前",
  comments: "2.4 万",
  read: "86.5 万",
  image:
    "https://readdy.ai/api/search-image?query=Abstract%20dramatic%20theatre%20spotlight%20on%20an%20empty%20stage%20with%20warm%20amber%20haze%20and%20soft%20smoke%2C%20cinematic%20editorial%20atmosphere%2C%20moody%20minimal%20composition%2C%20warm%20tones%2C%20high%20detail&width=1100&height=760&seq=hl-focus-main&orientation=landscape",
  imageAlt: "抽象舞台聚光灯下的置顶爆料主视觉",
};

export const heroSideCards: HeroCard[] = [
  {
    tag: "社会热议",
    title: "商场大屏换人事件迎来第三次反转，官方回应终于来了",
    summary: "两天内三次改口，网友直呼追剧都没这么刺激，关键时间线被重新排列。",
    author: "城市观察",
    time: "1 小时前",
    comments: "1.1 万",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20vintage%20broadcast%20microphone%20in%20warm%20amber%20studio%20light%2C%20clean%20simple%20background%2C%20editorial%20photography%2C%20warm%20tones%2C%20soft%20shadows%2C%20high%20detail&width=640&height=460&seq=hl-focus-mic&orientation=landscape",
    imageAlt: "暖色演播室中的复古麦克风特写",
  },
  {
    tag: "综艺风向",
    title: "新一季竞技综艺临时改规则，选手当场拒演引发热议",
    summary: "节目组与选手各执一词，一段后台路透被反复逐帧解读。",
    author: "综艺前线",
    time: "2 小时前",
    comments: "7,860",
    image:
      "https://readdy.ai/api/search-image?query=City%20skyline%20at%20dusk%20with%20warm%20golden%20window%20lights%20and%20soft%20bokeh%2C%20editorial%20urban%20photography%2C%20clean%20minimal%20composition%2C%20warm%20tones%2C%20high%20detail&width=640&height=460&seq=hl-focus-city&orientation=landscape",
    imageAlt: "黄昏城市的暖色灯光与虚化光斑",
  },
];

export const heroTopics: string[] = [
  "深夜发文",
  "团队换血",
  "综艺改规则",
  "商场大屏",
  "热搜第一",
  "后台路透",
  "演唱会退票",
  "官宣分手",
  "品牌撤换",
  "行程变动",
];

export const hotChatter: { text: string; time: string }[] = [
  { text: "三条动态看下来，只有第二条像是自己写的。", time: "12 分钟前" },
  { text: "路透那两分钟到底去哪了，蹲一个完整版。", time: "26 分钟前" },
  { text: "品牌方集体沉默这件事本身就很值得说。", time: "41 分钟前" },
  { text: "别急着下定论，我先搬个小板凳。", time: "58 分钟前" },
];

export const flashNews: FlashItem[] = [
  { time: "09:12", tag: "热榜", text: "某平台热榜首位出现全新词条，十分钟内讨论量破十万。" },
  { time: "08:47", tag: "回应", text: "当事工作室发布简短声明，仅回应行程问题，未触及核心质疑。" },
  { time: "08:20", tag: "路透", text: "一段后台视频流出，画面人数与官宣名单对不上，已被多次转存。" },
  { time: "07:58", tag: "品牌", text: "合作品牌连夜下架联名海报，客服统一回复为「系统维护」。" },
  { time: "07:30", tag: "后援会", text: "粉丝后援会发布长文，呼吁理性讨论、不要人肉无关人员。" },
  { time: "06:55", tag: "综艺", text: "节目官微更改置顶微博，原定档期疑似向后顺延。" },
  { time: "06:20", tag: "动态", text: "演员本人上线三分钟后离线，主页简介被改动一次。" },
  { time: "05:48", tag: "法律", text: "有网友整理出律师函模板，措辞与去年那件事几乎一致。" },
];

export const headlines: HeadlineItem[] = [
  {
    tag: "娱乐",
    title: "顶流代言连环撤换，品牌方集体沉默背后并不简单",
    summary: "三天之内四个品牌动作高度一致，业内人士称「很少有人事先通气到这个程度」。",
    source: "本站在线",
    time: "50 分钟前",
    comments: "1.2 万",
  },
  {
    tag: "社会",
    title: "深夜火锅店冲突视频刷屏，当事双方各发一份长文",
    summary: "监控与手机视频时长对不上，关键的两分钟至今仍是空白。",
    source: "社区爆料",
    time: "2 小时前",
    comments: "9,420",
  },
  {
    tag: "影视",
    title: "新剧开播三天口碑两极，编剧深夜发文又秒删",
    summary: "弹幕集中在后半段节奏，平台悄悄调整了首页推荐位。",
    source: "影视观察",
    time: "3 小时前",
    comments: "5,180",
  },
  {
    tag: "综艺",
    title: "年度综艺换血名单流出，三位常驻疑似集体缺席",
    summary: "路透照里座位排列发生变化，官方海报至今未更新。",
    source: "综艺前线",
    time: "4 小时前",
    comments: "3,760",
  },
  {
    tag: "音乐",
    title: "演唱会退票风波后续：主办方公布了新的座位方案",
    summary: "被遮挡区域的观众可换票或全额退，但补偿方案仍被吐槽。",
    source: "现场直击",
    time: "5 小时前",
    comments: "2,940",
  },
  {
    tag: "网络",
    title: "一条旧采访被重新翻出，评论区开始考据发布时间",
    summary: "截图上的水印与当年的平台版本不符，真伪仍在讨论中。",
    source: "考据小组",
    time: "6 小时前",
    comments: "1,860",
  },
];

export const recallItems: RecallItem[] = [
  { title: "某综艺停录传闻反转，节目组只回了四个字", time: "昨天 21:40" },
  { title: "品牌方撤下联名海报，客服话术高度统一", time: "昨天 19:05" },
  { title: "两位演员深夜互关又取关，粉丝忙到凌晨", time: "昨天 16:22" },
  { title: "一段彩排音频流出，被指与官宣曲目不符", time: "昨天 11:58" },
];

export const rankTabs: RankTab[] = [
  {
    key: "ent",
    label: "娱乐",
    items: [
      { rank: 1, title: "顶流工作室三条动态，措辞一次比一次谨慎", heat: 98, trend: "up", delta: "+12" },
      { rank: 2, title: "后台路透两分钟空白，被反复逐帧解读", heat: 94, trend: "up", delta: "+9" },
      { rank: 3, title: "品牌方连夜下架联名海报", heat: 89, trend: "same", delta: "0" },
      { rank: 4, title: "旧采访被翻出，水印对不上年份", heat: 83, trend: "down", delta: "-4" },
      { rank: 5, title: "两位演员深夜互关又取关", heat: 77, trend: "up", delta: "+6" },
      { rank: 6, title: "粉丝后援会发布理性讨论长文", heat: 71, trend: "down", delta: "-2" },
    ],
  },
  {
    key: "soc",
    label: "社会",
    items: [
      { rank: 1, title: "商场大屏换人事件第三次反转", heat: 96, trend: "up", delta: "+15" },
      { rank: 2, title: "深夜火锅店冲突，关键两分钟仍空白", heat: 91, trend: "up", delta: "+7" },
      { rank: 3, title: "小区电梯广告集体下架，居民说法不一", heat: 82, trend: "same", delta: "0" },
      { rank: 4, title: "地铁让座视频被剪成两个版本", heat: 76, trend: "down", delta: "-3" },
      { rank: 5, title: "外卖备注事件，平台公布处理结果", heat: 69, trend: "up", delta: "+5" },
      { rank: 6, title: "游客翻越护栏拍照被劝阻", heat: 63, trend: "down", delta: "-6" },
    ],
  },
  {
    key: "show",
    label: "综艺",
    items: [
      { rank: 1, title: "新一季竞技综艺临时改规则", heat: 93, trend: "up", delta: "+11" },
      { rank: 2, title: "年度综艺换血名单流出", heat: 88, trend: "up", delta: "+8" },
      { rank: 3, title: "节目官微更改置顶微博", heat: 81, trend: "same", delta: "0" },
      { rank: 4, title: "彩排音频流出，与官宣曲目不符", heat: 74, trend: "down", delta: "-5" },
      { rank: 5, title: "素人嘉宾旧视频被重新剪辑", heat: 67, trend: "up", delta: "+4" },
      { rank: 6, title: "棚内录制延期一周", heat: 61, trend: "down", delta: "-2" },
    ],
  },
  {
    key: "sport",
    label: "体育",
    items: [
      { rank: 1, title: "季前热身赛判罚争议，官方发布解释", heat: 90, trend: "up", delta: "+10" },
      { rank: 2, title: "主力球员赛前突然缺席训练", heat: 85, trend: "up", delta: "+6" },
      { rank: 3, title: "转会传闻反转，俱乐部未作回应", heat: 79, trend: "same", delta: "0" },
      { rank: 4, title: "主场门票临开赛前一小时售罄", heat: 72, trend: "up", delta: "+5" },
      { rank: 5, title: "赛程调整，两场比赛互换日期", heat: 66, trend: "down", delta: "-3" },
      { rank: 6, title: "青训名单公示，两名小将入选", heat: 60, trend: "down", delta: "-1" },
    ],
  },
];

export const heatCurve: number[] = [42, 55, 61, 48, 72, 88, 95, 91, 97, 84, 76, 69];

export const heatHours: string[] = [
  "00", "02", "04", "06", "08", "10", "12", "14", "16", "18", "20", "22",
];

export const discussionThreads: ThreadItem[] = [
  {
    avatar: "瓜",
    name: "瓜田里的猹",
    role: "常驻吃瓜",
    time: "12 分钟前",
    title: "大家觉得这次工作室的声明有几分可信？",
    summary: "三版声明看下来，措辞越来越保守，感觉后面还有第二波，先码住。",
    tags: ["深夜发文", "理性讨论"],
    replies: "326",
    likes: "1,204",
  },
  {
    avatar: "板",
    name: "板凳已就位",
    role: "资料党",
    time: "28 分钟前",
    title: "整理了一份时间线，欢迎补充和纠错",
    summary: "按公开信息把 7 天里的关键节点排了一遍，有对不上的地方求指路。",
    tags: ["时间线", "求纠错"],
    replies: "512",
    likes: "2,880",
  },
  {
    avatar: "路",
    name: "路过的好奇",
    role: "新来的",
    time: "45 分钟前",
    title: "品牌方集体沉默这件事，你们怎么看？",
    summary: "四个品牌动作几乎同步，这更像是统一节奏而不是各自决定。",
    tags: ["品牌撤换", "行业观察"],
    replies: "208",
    likes: "864",
  },
  {
    avatar: "翻",
    name: "反转爱好者",
    role: "考据小组",
    time: "1 小时前",
    title: "那张截图的版本号是不是有问题？",
    summary: "放大到水印位置看了半天，和当年客户端版本对不上，求懂行的。",
    tags: ["考据", "存疑"],
    replies: "174",
    likes: "703",
  },
  {
    avatar: "夜",
    name: "深夜也在线",
    role: "常驻吃瓜",
    time: "2 小时前",
    title: "蹲一个完整版路透，别只看剪辑片段",
    summary: "现在流传的版本都缺了关键两分钟，很容易被带偏，稳住。",
    tags: ["后台路透", "别急着站队"],
    replies: "289",
    likes: "1,156",
  },
  {
    avatar: "茶",
    name: "一杯敬热闹",
    role: "数据党",
    time: "3 小时前",
    title: "把今天的讨论量做了个小统计",
    summary: "热度和讨论量的峰值出现在上午十点，之后缓慢回落但仍在高位。",
    tags: ["数据", "热度观察"],
    replies: "143",
    likes: "598",
  },
];

export const galleryItems: GalleryItem[] = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20warm%20amber%20lighting%20and%20blurred%20silhouettes%2C%20documentary%20editorial%20photography%2C%20soft%20shadows%2C%20warm%20tones%2C%20clean%20composition&width=900&height=1120&seq=hl-gal-1&orientation=portrait",
    imageAlt: "暖色灯光下的后台通道",
    title: "后台通道抓拍：凌晨两点的走廊",
    tag: "后台",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Crowded%20press%20conference%20with%20raised%20hands%20and%20camera%20flashes%2C%20warm%20amber%20tone%2C%20documentary%20editorial%20photography%2C%20soft%20blur%2C%20high%20detail&width=860&height=640&seq=hl-gal-2&orientation=landscape",
    imageAlt: "被围堵的发布会现场",
    title: "发布会被围堵的那十分钟",
    tag: "现场",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20red%20and%20amber%20neon%20sign%20glow%20on%20a%20dark%20wall%2C%20minimal%20urban%20night%20photography%2C%20warm%20tones%2C%20clean%20composition&width=860&height=640&seq=hl-gal-3&orientation=landscape",
    imageAlt: "霓虹灯牌的红与琥珀光",
    title: "霓虹下的品牌灯牌",
    tag: "品牌",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Smartphone%20and%20coffee%20cup%20on%20a%20wooden%20cafe%20table%20in%20warm%20afternoon%20light%2C%20minimal%20lifestyle%20photography%2C%20warm%20tones%2C%20soft%20shadows&width=860&height=640&seq=hl-gal-4&orientation=landscape",
    imageAlt: "木质桌面上的手机与咖啡",
    title: "网友晒出的同款行程单",
    tag: "讨论",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Empty%20concert%20arena%20seats%20after%20the%20show%20with%20warm%20stage%20light%20left%20on%2C%20editorial%20photography%2C%20warm%20tones%2C%20clean%20composition&width=860&height=640&seq=hl-gal-5&orientation=landscape",
    imageAlt: "散场后的演唱会看台",
    title: "演唱会散场后的看台",
    tag: "现场",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20television%20screen%20with%20soft%20static%20in%20a%20dim%20warm%20room%2C%20retro%20editorial%20photography%2C%20warm%20tones%2C%20minimal%20composition&width=900&height=1120&seq=hl-gal-6&orientation=portrait",
    imageAlt: "暖光房间里的老式电视",
    title: "被反复解读的那张合照",
    tag: "考据",
  },
];

export const trustPoints: TrustPoint[] = [
  {
    icon: "ri-link-m",
    title: "来源标注",
    desc: "每条要闻都保留出处与发布时间，看到结论也能看到它从哪来。",
  },
  {
    icon: "ri-refresh-line",
    title: "实时更新",
    desc: "短讯快报随讨论热度滚动刷新，事件进展不再散落在各个角落。",
  },
  {
    icon: "ri-shield-check-line",
    title: "社区共治",
    desc: "纠错与举报由编辑部当日处理，处理结果在原条目上标注说明。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "不追流量",
    desc: "热度榜保留涨跌轨迹，拒绝一条爆料长期霸占置顶位置。",
  },
];

export const trustStats: TrustStat[] = [
  { value: "2,860", label: "今日收录条目" },
  { value: "48 万", label: "社区讨论总条数" },
  { value: "96%", label: "纠错当日处理率" },
];

export const faqItems: FaqItem[] = [
  {
    question: "黑料首页的内容究竟从哪来？",
    answer:
      "头版焦点与今日要闻由编辑整理站内讨论热度较高的公开信息，并标注来源与时间，方便你快速了解来龙去脉，而不是只看到一句结论。",
  },
  {
    question: "置顶爆料是怎么选出来的？",
    answer:
      "置顶位置综合讨论量、转载速度与社区投票实时更新，热度回落后会自动下沉，不会人为长期占位，也不会因为合作而保留固定席位。",
  },
  {
    question: "看到疑似不实的信息怎么办？",
    answer:
      "每条内容下方都可以提交纠错。我们会在核实后更新或下架，并在原条目上标注修改时间与原因，让改动本身也是可追溯的。",
  },
  {
    question: "讨论区有什么规则？",
    answer:
      "社区鼓励就事论事，禁止人肉搜索、泄露隐私与辱骂他人。违规内容会被折叠并记录，重复违规将限制发言，保证这里的讨论氛围。",
  },
  {
    question: "为什么有些条目只有短摘要？",
    answer:
      "为了保证列表页的信息密度，我们只保留标题与短摘要。随着事件推进，完整脉络会在原条目的更新中逐步补齐，不必来回翻页。",
  },
];

export const footerColumns: { title: string; links: NavLink[] }[] = [
  {
    title: "浏览栏目",
    links: [
      { label: "头版焦点", href: "#focus" },
      { label: "短讯快报", href: "#flash" },
      { label: "今日要闻", href: "#headlines" },
      { label: "热瓜榜", href: "#rank" },
    ],
  },
  {
    title: "参与社区",
    links: [
      { label: "吃瓜讨论区", href: "#discussion" },
      { label: "爆料图鉴", href: "#gallery" },
      { label: "信任与解答", href: "#trust" },
      { label: "提交纠错", href: "#trust" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "编辑原则", href: "#trust" },
      { label: "来源说明", href: "#trust" },
      { label: "社区守则", href: "#trust" },
      { label: "联系我们", href: "#trust" },
    ],
  },
];